import React, { useEffect } from 'react';
import { drawBloodPressureChart, drawPPGChart, drawRespoiratoryChart, drawGlucoseChart, drawSpO2Chart, drawTempChart, drawWeightChart, drawStepsChart, drawCaloriesChart, drawHrvChart, drawHrvLfHfChart, drawSleepChart, drawPWVChart } from '@cardiacsense/cs-charts-module';
import ChartBox from './cart-box';
import { capitalizeWords } from '../utils/formaters';
import { chart_height, initialMesutments, pdf_chart_height, pdf_width, print_height, print_width } from '../consts';
import _ from 'lodash';
import moment from 'moment';
import { useWindowSize } from '../hooks/useOnResize';
import { convertConfigurationsToBooleans } from '../utils/general-utils';
function MonthlyCharts({ chartsData, configurations, user, isPdf, isBpReport = false }) {
    var _a;
    const [width] = useWindowSize();
    let thresholdsStatus = (_a = configurations === null || configurations === void 0 ? void 0 : configurations.alerts) === null || _a === void 0 ? void 0 : _a.thresholds;
    configurations = convertConfigurationsToBooleans(configurations);
    useEffect(() => {
        drawCharts();
    }, [width]);
    const meaurments = initialMesutments(user);
    const units = _.mapValues(meaurments, ({ unit }) => unit);
    const { thresholds } = user;
    const allCharts = () => isBpReport ? ({
        "blood-pressure": {
            draw: drawBloodPressureChart,
            data: [...chartsData.bloodPressureData]
        }
    }) : ({
        "pulse-rate": { draw: drawPPGChart, data: [...chartsData.pulseRateData] },
        "respiratory-rate": { draw: drawRespoiratoryChart, data: [...chartsData.respiratoryRateData] },
        "SpO2": { draw: drawSpO2Chart, data: [...chartsData.spo2Data] },
        "blood-pressure": {
            draw: drawBloodPressureChart,
            data: [...chartsData.bloodPressureData]
        },
        "body-temp": { draw: drawTempChart, data: [...chartsData.bodyTempData] },
        "glucose": { draw: drawGlucoseChart, data: [...chartsData.glucoseData] },
        "weight": { draw: drawWeightChart, data: [...chartsData.weightData] },
        "pwv": { draw: drawPWVChart, data: [...chartsData.pwvData] },
        "hrv_pr": { draw: drawHrvChart, data: [...chartsData.hrvData, null] },
        "hrv_lfhf": { draw: drawHrvLfHfChart, data: [...chartsData.lfhfData, null] },
        "calories": { draw: drawCaloriesChart, data: [...chartsData.caloriesData, null] },
        "steps": { draw: drawStepsChart, data: [...chartsData.stepsData, null] },
        "sleep": { draw: drawSleepChart, data: [...chartsData.sleepData, null] }
    });
    const drawCharts = () => {
        var _a, _b;
        const charts = allCharts();
        const daysInMonth = (_b = (_a = charts['blood-pressure']) === null || _a === void 0 ? void 0 : _a.data[0]) === null || _b === void 0 ? void 0 : _b.length;
        let dynamic_pdf_width = pdf_width - ((30 - daysInMonth) * 30); //smaller charts for smaller month 
        const width = isPdf ? dynamic_pdf_width : window.innerWidth - (window.innerWidth / 15);
        const height = isPdf ? pdf_chart_height : chart_height;
        Object.keys(charts).forEach((type) => {
            if (!configurations[type.replace('-', '_').toLowerCase()])
                return;
            const { draw, data } = charts[type];
            const unitName = capitalizeWords(type.replace('-', ' '));
            const chartSVG = draw(...data, thresholds, (date) => window.open(`/static/reports/daily-report/${moment(date).format('YYYY-MM-DD')}`, "_blank"), width, height, units[unitName], thresholdsStatus);
            const wrapCharts = document.createElement('div');
            const wrapBrowserChart = document.createElement('div');
            wrapBrowserChart.setAttribute('class', `${!isPdf ? 'print-hide' : ''} pdf-cut-guard`);
            wrapBrowserChart.appendChild(chartSVG);
            wrapCharts.appendChild(wrapBrowserChart);
            // draw the same chart beat smaller for printing in portal
            if (!isPdf) {
                const chartSVGPrint = draw(...data, thresholds, (date) => window.open(`/static/reports/daily-report/${moment(date).format('YYYY-MM-DD')}`, "_blank"), print_width, print_height, units[unitName], thresholdsStatus);
                const wrapPrintChart = document.createElement('div');
                wrapPrintChart.setAttribute('class', 'print-show pdf-cut-guard');
                wrapPrintChart.appendChild(chartSVGPrint);
                wrapCharts.appendChild(wrapPrintChart);
            }
            const chartNode = document.getElementsByClassName(`${type}-chart`)[0];
            if (chartNode.hasChildNodes()) {
                chartNode.replaceChild(wrapCharts, chartNode.childNodes[0]);
            }
            else {
                chartNode.appendChild(wrapCharts);
            }
        });
    };
    return (React.createElement("div", { className: 'text-center' }, Object.keys(allCharts()).map(type => React.createElement(ChartBox, { key: type, type: type, configurations: configurations, isPdf: isPdf }))));
}
export default MonthlyCharts;
